/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_Dns_PendingInputs */

const en_backend_session_dns_pending = /** @type {(inputs: Backend_Session_Dns_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provisioning...`)
};

const fr_backend_session_dns_pending = /** @type {(inputs: Backend_Session_Dns_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provisionnement...`)
};

const ms_sg2_backend_session_dns_pending = /** @type {(inputs: Backend_Session_Dns_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyediaan...`)
};

/**
* | output |
* | --- |
* | "Provisioning..." |
*
* @param {Backend_Session_Dns_PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_dns_pending = /** @type {((inputs?: Backend_Session_Dns_PendingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Dns_PendingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_dns_pending(inputs)
	if (locale === "fr") return fr_backend_session_dns_pending(inputs)
	return ms_sg2_backend_session_dns_pending(inputs)
});